const urlName = '/usercenter/v1'
export default API => ({
    // 退出登录
    logout({data, params}) {
        return API({
            url: `${urlName}/account/logout` ,
            method:  'post',
            data,
            params
        });
    },
    // 分校列表
    getFindUserBranchList({data, params}) {
        return API({
            url: `${urlName}/account/findUserBranchList` ,
            data,
            params
        });
    },
    // 列表
    accountProfile(id) {
        return API({
            url: `${urlName}/accountProfile/findById?id=${id}` ,
            method:  'get',
        });
    },
    
    accountProfileSave(data) {
        return API({
            url: `${urlName}/accountProfile/updateAccountInfo` ,
            method:  'post',
            data
        });
    },
    // 个人资料
    findUserDetail() {
        return API({
            url: `company/v1/user/findMyDetail` ,
            method:  'get'
        });
    },
    //编辑保存个人资料
    userDetailSave(data) {
        return API({
            url: `company/v1/user/save` ,
            method:  'post',
            data
        });
    },
    //获取城市列表
    getRegionList() {
        return API({
            url: `company/v1/region/regionList` ,
            method:  'get'
        });
    },


    //订单详情
    getOrderList(data,params) {
        return API({ 
            url: `/order/v1/open/order/myOrderListWithPage?pageSize=${params.pageSize}&pageNum=${params.pageNum}`, 
            method:  'get',
            params: data,
        });
    },
})
